import { _ as _root } from "./auth-service-tools993.js";
var root = _root;
var Symbol$1 = root.Symbol;
var _Symbol = Symbol$1;
export { _Symbol as _ };